/* eslint-disable no-restricted-globals */
import moment from 'moment';

export const formatDate = (date?: string | number) => {
	const dateToFormat = isNaN(+date) ? date : new Date(+date);
	return moment(dateToFormat || '').format('DD/MM/YYYY [as] hh:mm:ss');
};
